/** Saved submission identity, never inferred from a brand's current team. */
export function submitterLabel(name: string | null | undefined): string {
  return name?.trim() ? `Briefed by ${name.trim()}` : "Briefed by: not recorded";
}

export function SubmittedBy({ name }: { name: string | null | undefined }) {
  return <span className="wk-submitter">{submitterLabel(name)}</span>;
}
